export enum QueryKeys {
    RECEIPT = 'receipt',
    VOUCHERS = 'vouchers',
    POINTS_LIST = 'pointsList',
    MEMBER_REWARDS = 'memberRewards',
    ACTIVE_VOUCHERS = 'activeVouchers',
    PURCHASE_HISTORY = 'purchaseHistory',
    ACTIVE_MEMBER_REWARDS = 'activeMemberRewards',
    MEMBER_ACCOUNT_INFORMATION = 'memberAccountInformation',
}

export enum MutationKeys {
    ADD_REWARD = 'addReward',
    REMOVE_REWARD = 'removeReward',
    RESERVE_REWARD = 'reserveReward',
    RELEASE_REWARD = 'releaseReward',
    RESERVE_VOUCHER = 'reserveVoucher',
    RELEASE_VOUCHER = 'releaseVoucher',
}

export enum ScopedMutationKeys {
    SCOPED_REWARDS = 'scopedRewards',
    SCOPED_VOUCHERS = 'scopedVouchers',
}
